import { Component } from 'react'
import { ProductAnnouncement, SenderInfo } from 'shared-web/src/components/widget/TakeoverCampaign'

import styles from './style'

export default class TakeoverMessageBuilder extends Component {
  render() {
    const {
      widgetContent: { message, headline, ctaCopy, selectedUser },
      defaultEmbed: { organizationName, theme },
      hideCta,
    } = this.props
    return (
      <div key="takeover-preview">
        <div className={styles.TakeoverPreview}>
          <div className="takeover">
            <ProductAnnouncement
              headline={headline}
              ctaCopy={!hideCta && ctaCopy}
              ctaHref={''}
              theme="LIGHT"
              showBranding={false}
              primaryColor={`#${theme.backgroundColor}`}
            >
              <div
                className={styles.TakeoverContent}
                dangerouslySetInnerHTML={{ __html: message }}
              />
              {selectedUser &&
                <SenderInfo
                  displayName={selectedUser.name || selectedUser.email}
                  orgName={organizationName}
                  sender={selectedUser}
                />
              }
            </ProductAnnouncement>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/shared/MessagePreviews/TakeoverMessage/TakeoverMessageBuilder/index.js